var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 506,
    viewBox: "0 0 115 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.1393 314.06C91.1393 314.06 98.6438 335 91.1393 335C83.6347 335 91.1393 314.06 91.1393 314.06Z",
    fill: "#FFE900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1392 313.94C91.1392 313.94 83.6346 293 91.1392 293C98.7648 293 91.1392 313.94 91.1392 313.94Z",
    fill: "#FFE900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 314.061C91.1406 314.061 70.2005 321.565 70.2005 314.061C70.2005 306.556 91.1406 314.061 91.1406 314.061Z",
    fill: "#FFE900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2601 314.061C91.2601 314.061 112.2 306.556 112.2 314.061C112.2 321.565 91.2601 314.061 91.2601 314.061Z",
    fill: "#FFE900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 314.061C91.1406 314.061 81.6994 334.275 76.2526 328.949C70.9268 323.502 91.1406 314.061 91.1406 314.061Z",
    fill: "#FFE900"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.139 313.94C91.139 313.94 100.58 293.726 106.027 299.052C111.474 304.378 91.139 313.94 91.139 313.94Z",
    fill: "#FFE900"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 313.94C91.1406 313.94 70.9268 304.499 76.2526 299.052C81.5784 293.847 91.1406 313.94 91.1406 313.94Z",
    fill: "#FFE900"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.139 314.062C91.139 314.062 111.353 323.504 106.027 328.951C100.701 334.155 91.139 314.062 91.139 314.062Z",
    fill: "#FFE900"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1407 314.061C91.1407 314.061 106.392 330.281 99.4925 333.307C92.5932 336.333 91.1407 314.061 91.1407 314.061Z",
    fill: "#FAD300"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 313.94C91.1406 313.94 75.8895 297.72 82.7888 294.694C89.6882 291.668 91.1406 313.94 91.1406 313.94Z",
    fill: "#FAD300"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 314.063C91.1406 314.063 74.9212 329.314 71.8951 322.414C68.8691 315.394 91.1406 314.063 91.1406 314.063Z",
    fill: "#FAD300"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2604 313.94C91.2604 313.94 107.48 298.689 110.506 305.588C113.411 312.608 91.2604 313.94 91.2604 313.94Z",
    fill: "#FAD300"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 314.062C91.1406 314.062 90.4144 336.333 83.394 333.549C76.3737 330.765 91.1406 314.062 91.1406 314.062Z",
    fill: "#FAD300"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1387 313.94C91.1387 313.94 91.865 291.668 98.8854 294.452C105.906 297.236 91.1387 313.94 91.1387 313.94Z",
    fill: "#FAD300"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 313.94C91.1406 313.94 68.8691 313.214 71.653 306.193C74.437 299.294 91.1406 313.94 91.1406 313.94Z",
    fill: "#FAD300"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2599 314.062C91.2599 314.062 113.531 314.788 110.747 321.808C107.964 328.708 91.2599 314.062 91.2599 314.062Z",
    fill: "#FAD300"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.75 314.06C87.75 312.244 89.2025 310.671 91.1391 310.671C92.9547 310.671 94.5283 312.123 94.5283 314.06C94.5283 315.876 93.0758 317.449 91.1391 317.449C89.3235 317.449 87.75 315.876 87.75 314.06Z",
    fill: "#FAD300"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1393 483.06C91.1393 483.06 98.6438 504 91.1393 504C83.6347 504 91.1393 483.06 91.1393 483.06Z",
    fill: "#FFE900"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1392 482.94C91.1392 482.94 83.6346 462 91.1392 462C98.7648 462 91.1392 482.94 91.1392 482.94Z",
    fill: "#FFE900"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 483.061C91.1406 483.061 70.2005 490.565 70.2005 483.061C70.2005 475.556 91.1406 483.061 91.1406 483.061Z",
    fill: "#FFE900"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2601 483.061C91.2601 483.061 112.2 475.556 112.2 483.061C112.2 490.565 91.2601 483.061 91.2601 483.061Z",
    fill: "#FFE900"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 483.061C91.1406 483.061 81.6994 503.275 76.2526 497.949C70.9268 492.502 91.1406 483.061 91.1406 483.061Z",
    fill: "#FFE900"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M91.139 482.94C91.139 482.94 100.58 462.726 106.027 468.052C111.474 473.378 91.139 482.94 91.139 482.94Z",
    fill: "#FFE900"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 482.94C91.1406 482.94 70.9268 473.499 76.2526 468.052C81.5784 462.847 91.1406 482.94 91.1406 482.94Z",
    fill: "#FFE900"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M91.139 483.062C91.139 483.062 111.353 492.504 106.027 497.951C100.701 503.155 91.139 483.062 91.139 483.062Z",
    fill: "#FFE900"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1407 483.061C91.1407 483.061 106.392 499.281 99.4925 502.307C92.5932 505.333 91.1407 483.061 91.1407 483.061Z",
    fill: "#FAD300"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 482.94C91.1406 482.94 75.8895 466.72 82.7888 463.694C89.6882 460.668 91.1406 482.94 91.1406 482.94Z",
    fill: "#FAD300"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 483.063C91.1406 483.063 74.9212 498.314 71.8951 491.414C68.8691 484.394 91.1406 483.063 91.1406 483.063Z",
    fill: "#FAD300"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2604 482.94C91.2604 482.94 107.48 467.689 110.506 474.588C113.411 481.608 91.2604 482.94 91.2604 482.94Z",
    fill: "#FAD300"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 483.062C91.1406 483.062 90.4144 505.333 83.394 502.549C76.3737 499.765 91.1406 483.062 91.1406 483.062Z",
    fill: "#FAD300"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1387 482.94C91.1387 482.94 91.865 460.668 98.8854 463.452C105.906 466.236 91.1387 482.94 91.1387 482.94Z",
    fill: "#FAD300"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 482.94C91.1406 482.94 68.8691 482.214 71.653 475.193C74.437 468.294 91.1406 482.94 91.1406 482.94Z",
    fill: "#FAD300"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2599 483.062C91.2599 483.062 113.531 483.788 110.747 490.808C107.964 497.708 91.2599 483.062 91.2599 483.062Z",
    fill: "#FAD300"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M87.75 483.06C87.75 481.244 89.2025 479.671 91.1391 479.671C92.9547 479.671 94.5283 481.123 94.5283 483.06C94.5283 484.876 93.0758 486.449 91.1391 486.449C89.3235 486.449 87.75 484.876 87.75 483.06Z",
    fill: "#FAD300"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1393 105.06C93.1393 105.06 100.644 126 93.1393 126C85.6347 126 93.1393 105.06 93.1393 105.06Z",
    fill: "#FFE900"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1392 104.94C93.1392 104.94 85.6346 83.9999 93.1392 83.9999C100.765 83.9999 93.1392 104.94 93.1392 104.94Z",
    fill: "#FFE900"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 105.061C93.1406 105.061 72.2005 112.565 72.2005 105.061C72.2005 97.5561 93.1406 105.061 93.1406 105.061Z",
    fill: "#FFE900"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2601 105.061C93.2601 105.061 114.2 97.5561 114.2 105.061C114.2 112.565 93.2601 105.061 93.2601 105.061Z",
    fill: "#FFE900"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 105.061C93.1406 105.061 83.6994 125.275 78.2526 119.949C72.9268 114.502 93.1406 105.061 93.1406 105.061Z",
    fill: "#FFE900"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M93.139 104.94C93.139 104.94 102.58 84.7261 108.027 90.0519C113.474 95.3777 93.139 104.94 93.139 104.94Z",
    fill: "#FFE900"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 104.94C93.1406 104.94 72.9268 95.4988 78.2526 90.0519C83.5784 84.8472 93.1406 104.94 93.1406 104.94Z",
    fill: "#FFE900"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M93.139 105.062C93.139 105.062 113.353 114.504 108.027 119.951C102.701 125.155 93.139 105.062 93.139 105.062Z",
    fill: "#FFE900"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1407 105.061C93.1407 105.061 108.392 121.281 101.493 124.307C94.5932 127.333 93.1407 105.061 93.1407 105.061Z",
    fill: "#FAD300"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 104.94C93.1406 104.94 77.8895 88.7205 84.7888 85.6944C91.6882 82.6684 93.1406 104.94 93.1406 104.94Z",
    fill: "#FAD300"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 105.063C93.1406 105.063 76.9212 120.314 73.8951 113.414C70.8691 106.394 93.1406 105.063 93.1406 105.063Z",
    fill: "#FAD300"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2604 104.94C93.2604 104.94 109.48 89.6888 112.506 96.5881C115.411 103.608 93.2604 104.94 93.2604 104.94Z",
    fill: "#FAD300"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 105.062C93.1406 105.062 92.4144 127.333 85.394 124.549C78.3737 121.765 93.1406 105.062 93.1406 105.062Z",
    fill: "#FAD300"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1387 104.94C93.1387 104.94 93.865 82.6684 100.885 85.4524C107.906 88.2363 93.1387 104.94 93.1387 104.94Z",
    fill: "#FAD300"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 104.94C93.1406 104.94 70.8691 104.214 73.653 97.1933C76.437 90.294 93.1406 104.94 93.1406 104.94Z",
    fill: "#FAD300"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2599 105.062C93.2599 105.062 115.531 105.788 112.747 112.808C109.964 119.708 93.2599 105.062 93.2599 105.062Z",
    fill: "#FAD300"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M89.75 105.06C89.75 103.244 91.2025 101.671 93.1391 101.671C94.9547 101.671 96.5283 103.123 96.5283 105.06C96.5283 106.876 95.0758 108.449 93.1391 108.449C91.3235 108.449 89.75 106.876 89.75 105.06Z",
    fill: "#FAD300"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1393 272.06C91.1393 272.06 98.6438 293 91.1393 293C83.6347 293 91.1393 272.06 91.1393 272.06Z",
    fill: "#FFE900"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1392 271.94C91.1392 271.94 83.6346 251 91.1392 251C98.7648 251 91.1392 271.94 91.1392 271.94Z",
    fill: "#FFE900"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 272.061C91.1406 272.061 70.2005 279.565 70.2005 272.061C70.2005 264.556 91.1406 272.061 91.1406 272.061Z",
    fill: "#FFE900"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2601 272.061C91.2601 272.061 112.2 264.556 112.2 272.061C112.2 279.565 91.2601 272.061 91.2601 272.061Z",
    fill: "#FFE900"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 272.061C91.1406 272.061 81.6994 292.275 76.2526 286.949C70.9268 281.502 91.1406 272.061 91.1406 272.061Z",
    fill: "#FFE900"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M91.139 271.94C91.139 271.94 100.58 251.726 106.027 257.052C111.474 262.378 91.139 271.94 91.139 271.94Z",
    fill: "#FFE900"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 271.94C91.1406 271.94 70.9268 262.499 76.2526 257.052C81.5784 251.847 91.1406 271.94 91.1406 271.94Z",
    fill: "#FFE900"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M91.139 272.062C91.139 272.062 111.353 281.504 106.027 286.951C100.701 292.155 91.139 272.062 91.139 272.062Z",
    fill: "#FFE900"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1407 272.061C91.1407 272.061 106.392 288.281 99.4925 291.307C92.5932 294.333 91.1407 272.061 91.1407 272.061Z",
    fill: "#FAD300"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 271.94C91.1406 271.94 75.8895 255.72 82.7888 252.694C89.6882 249.668 91.1406 271.94 91.1406 271.94Z",
    fill: "#FAD300"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 272.063C91.1406 272.063 74.9212 287.314 71.8951 280.414C68.8691 273.394 91.1406 272.063 91.1406 272.063Z",
    fill: "#FAD300"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2604 271.94C91.2604 271.94 107.48 256.689 110.506 263.588C113.411 270.608 91.2604 271.94 91.2604 271.94Z",
    fill: "#FAD300"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 272.062C91.1406 272.062 90.4144 294.333 83.394 291.549C76.3737 288.765 91.1406 272.062 91.1406 272.062Z",
    fill: "#FAD300"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1387 271.94C91.1387 271.94 91.865 249.668 98.8854 252.452C105.906 255.236 91.1387 271.94 91.1387 271.94Z",
    fill: "#FAD300"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 271.94C91.1406 271.94 68.8691 271.214 71.653 264.193C74.437 257.294 91.1406 271.94 91.1406 271.94Z",
    fill: "#FAD300"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2599 272.062C91.2599 272.062 113.531 272.788 110.747 279.808C107.964 286.708 91.2599 272.062 91.2599 272.062Z",
    fill: "#FAD300"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M87.75 272.06C87.75 270.244 89.2025 268.671 91.1391 268.671C92.9547 268.671 94.5283 270.123 94.5283 272.06C94.5283 273.876 93.0758 275.449 91.1391 275.449C89.3235 275.449 87.75 273.876 87.75 272.06Z",
    fill: "#FAD300"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1393 441.06C91.1393 441.06 98.6438 462 91.1393 462C83.6347 462 91.1393 441.06 91.1393 441.06Z",
    fill: "#FFE900"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1392 440.94C91.1392 440.94 83.6346 420 91.1392 420C98.7648 420 91.1392 440.94 91.1392 440.94Z",
    fill: "#FFE900"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 441.061C91.1406 441.061 70.2005 448.565 70.2005 441.061C70.2005 433.556 91.1406 441.061 91.1406 441.061Z",
    fill: "#FFE900"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2601 441.061C91.2601 441.061 112.2 433.556 112.2 441.061C112.2 448.565 91.2601 441.061 91.2601 441.061Z",
    fill: "#FFE900"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 441.061C91.1406 441.061 81.6994 461.275 76.2526 455.949C70.9268 450.502 91.1406 441.061 91.1406 441.061Z",
    fill: "#FFE900"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M91.139 440.94C91.139 440.94 100.58 420.726 106.027 426.052C111.474 431.378 91.139 440.94 91.139 440.94Z",
    fill: "#FFE900"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 440.94C91.1406 440.94 70.9268 431.499 76.2526 426.052C81.5784 420.847 91.1406 440.94 91.1406 440.94Z",
    fill: "#FFE900"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M91.139 441.062C91.139 441.062 111.353 450.504 106.027 455.951C100.701 461.155 91.139 441.062 91.139 441.062Z",
    fill: "#FFE900"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1407 441.061C91.1407 441.061 106.392 457.281 99.4925 460.307C92.5932 463.333 91.1407 441.061 91.1407 441.061Z",
    fill: "#FAD300"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 440.94C91.1406 440.94 75.8895 424.72 82.7888 421.694C89.6882 418.668 91.1406 440.94 91.1406 440.94Z",
    fill: "#FAD300"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 441.063C91.1406 441.063 74.9212 456.314 71.8951 449.414C68.8691 442.394 91.1406 441.063 91.1406 441.063Z",
    fill: "#FAD300"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2604 440.94C91.2604 440.94 107.48 425.689 110.506 432.588C113.411 439.608 91.2604 440.94 91.2604 440.94Z",
    fill: "#FAD300"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 441.062C91.1406 441.062 90.4144 463.333 83.394 460.549C76.3737 457.765 91.1406 441.062 91.1406 441.062Z",
    fill: "#FAD300"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1387 440.94C91.1387 440.94 91.865 418.668 98.8854 421.452C105.906 424.236 91.1387 440.94 91.1387 440.94Z",
    fill: "#FAD300"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 440.94C91.1406 440.94 68.8691 440.214 71.653 433.193C74.437 426.294 91.1406 440.94 91.1406 440.94Z",
    fill: "#FAD300"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2599 441.062C91.2599 441.062 113.531 441.788 110.747 448.808C107.964 455.708 91.2599 441.062 91.2599 441.062Z",
    fill: "#FAD300"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M87.75 441.06C87.75 439.244 89.2025 437.671 91.1391 437.671C92.9547 437.671 94.5283 439.123 94.5283 441.06C94.5283 442.876 93.0758 444.449 91.1391 444.449C89.3235 444.449 87.75 442.876 87.75 441.06Z",
    fill: "#FAD300"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1393 63.0599C93.1393 63.0599 100.644 84 93.1393 84C85.6347 84 93.1393 63.0599 93.1393 63.0599Z",
    fill: "#FFE900"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1392 62.9399C93.1392 62.9399 85.6346 41.9999 93.1392 41.9999C100.765 41.9999 93.1392 62.9399 93.1392 62.9399Z",
    fill: "#FFE900"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 63.0606C93.1406 63.0606 72.2005 70.5652 72.2005 63.0606C72.2005 55.5561 93.1406 63.0606 93.1406 63.0606Z",
    fill: "#FFE900"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2601 63.0606C93.2601 63.0606 114.2 55.5561 114.2 63.0606C114.2 70.5652 93.2601 63.0606 93.2601 63.0606Z",
    fill: "#FFE900"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 63.0609C93.1406 63.0609 83.6994 83.2748 78.2526 77.949C72.9268 72.5021 93.1406 63.0609 93.1406 63.0609Z",
    fill: "#FFE900"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M93.139 62.9399C93.139 62.9399 102.58 42.7261 108.027 48.0519C113.474 53.3777 93.139 62.9399 93.139 62.9399Z",
    fill: "#FFE900"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 62.9399C93.1406 62.9399 72.9268 53.4988 78.2526 48.0519C83.5784 42.8472 93.1406 62.9399 93.1406 62.9399Z",
    fill: "#FFE900"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M93.139 63.0625C93.139 63.0625 113.353 72.5037 108.027 77.9505C102.701 83.1553 93.139 63.0625 93.139 63.0625Z",
    fill: "#FFE900"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1407 63.0612C93.1407 63.0612 108.392 79.2807 101.493 82.3067C94.5932 85.3328 93.1407 63.0612 93.1407 63.0612Z",
    fill: "#FAD300"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 62.9399C93.1406 62.9399 77.8895 46.7205 84.7888 43.6944C91.6882 40.6684 93.1406 62.9399 93.1406 62.9399Z",
    fill: "#FAD300"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 63.0626C93.1406 63.0626 76.9212 78.3137 73.8951 71.4144C70.8691 64.394 93.1406 63.0626 93.1406 63.0626Z",
    fill: "#FAD300"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2604 62.9399C93.2604 62.9399 109.48 47.6888 112.506 54.5881C115.411 61.6085 93.2604 62.9399 93.2604 62.9399Z",
    fill: "#FAD300"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 63.0616C93.1406 63.0616 92.4144 85.3332 85.394 82.5492C78.3737 79.7653 93.1406 63.0616 93.1406 63.0616Z",
    fill: "#FAD300"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1387 62.9399C93.1387 62.9399 93.865 40.6684 100.885 43.4524C107.906 46.2363 93.1387 62.9399 93.1387 62.9399Z",
    fill: "#FAD300"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 62.9399C93.1406 62.9399 70.8691 62.2137 73.653 55.1933C76.437 48.294 93.1406 62.9399 93.1406 62.9399Z",
    fill: "#FAD300"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2599 63.0616C93.2599 63.0616 115.531 63.7879 112.747 70.8082C109.964 77.7076 93.2599 63.0616 93.2599 63.0616Z",
    fill: "#FAD300"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M89.75 63.0601C89.75 61.2445 91.2025 59.6709 93.1391 59.6709C94.9547 59.6709 96.5283 61.1234 96.5283 63.0601C96.5283 64.8757 95.0758 66.4492 93.1391 66.4492C91.3235 66.4492 89.75 64.8757 89.75 63.0601Z",
    fill: "#FAD300"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1393 399.06C91.1393 399.06 98.6438 420 91.1393 420C83.6347 420 91.1393 399.06 91.1393 399.06Z",
    fill: "#FFE900"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1392 398.94C91.1392 398.94 83.6346 378 91.1392 378C98.7648 378 91.1392 398.94 91.1392 398.94Z",
    fill: "#FFE900"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 399.061C91.1406 399.061 70.2005 406.565 70.2005 399.061C70.2005 391.556 91.1406 399.061 91.1406 399.061Z",
    fill: "#FFE900"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2601 399.061C91.2601 399.061 112.2 391.556 112.2 399.061C112.2 406.565 91.2601 399.061 91.2601 399.061Z",
    fill: "#FFE900"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 399.061C91.1406 399.061 81.6994 419.275 76.2526 413.949C70.9268 408.502 91.1406 399.061 91.1406 399.061Z",
    fill: "#FFE900"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M91.139 398.94C91.139 398.94 100.58 378.726 106.027 384.052C111.474 389.378 91.139 398.94 91.139 398.94Z",
    fill: "#FFE900"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 398.94C91.1406 398.94 70.9268 389.499 76.2526 384.052C81.5784 378.847 91.1406 398.94 91.1406 398.94Z",
    fill: "#FFE900"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M91.139 399.062C91.139 399.062 111.353 408.504 106.027 413.951C100.701 419.155 91.139 399.062 91.139 399.062Z",
    fill: "#FFE900"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1407 399.061C91.1407 399.061 106.392 415.281 99.4925 418.307C92.5932 421.333 91.1407 399.061 91.1407 399.061Z",
    fill: "#FAD300"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 398.94C91.1406 398.94 75.8895 382.72 82.7888 379.694C89.6882 376.668 91.1406 398.94 91.1406 398.94Z",
    fill: "#FAD300"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 399.063C91.1406 399.063 74.9212 414.314 71.8951 407.414C68.8691 400.394 91.1406 399.063 91.1406 399.063Z",
    fill: "#FAD300"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2604 398.94C91.2604 398.94 107.48 383.689 110.506 390.588C113.411 397.608 91.2604 398.94 91.2604 398.94Z",
    fill: "#FAD300"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 399.062C91.1406 399.062 90.4144 421.333 83.394 418.549C76.3737 415.765 91.1406 399.062 91.1406 399.062Z",
    fill: "#FAD300"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1387 398.94C91.1387 398.94 91.865 376.668 98.8854 379.452C105.906 382.236 91.1387 398.94 91.1387 398.94Z",
    fill: "#FAD300"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 398.94C91.1406 398.94 68.8691 398.214 71.653 391.193C74.437 384.294 91.1406 398.94 91.1406 398.94Z",
    fill: "#FAD300"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2599 399.062C91.2599 399.062 113.531 399.788 110.747 406.808C107.964 413.708 91.2599 399.062 91.2599 399.062Z",
    fill: "#FAD300"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M87.75 399.06C87.75 397.244 89.2025 395.671 91.1391 395.671C92.9547 395.671 94.5283 397.123 94.5283 399.06C94.5283 400.876 93.0758 402.449 91.1391 402.449C89.3235 402.449 87.75 400.876 87.75 399.06Z",
    fill: "#FAD300"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1393 21.0599C93.1393 21.0599 100.644 42 93.1393 42C85.6347 42 93.1393 21.0599 93.1393 21.0599Z",
    fill: "#FFE900"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1392 20.9399C93.1392 20.9399 85.6346 -0.00012207 93.1392 -0.00012207C100.765 -0.00012207 93.1392 20.9399 93.1392 20.9399Z",
    fill: "#FFE900"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 21.0606C93.1406 21.0606 72.2005 28.5652 72.2005 21.0606C72.2005 13.5561 93.1406 21.0606 93.1406 21.0606Z",
    fill: "#FFE900"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2601 21.0606C93.2601 21.0606 114.2 13.5561 114.2 21.0606C114.2 28.5652 93.2601 21.0606 93.2601 21.0606Z",
    fill: "#FFE900"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 21.0609C93.1406 21.0609 83.6994 41.2748 78.2526 35.949C72.9268 30.5021 93.1406 21.0609 93.1406 21.0609Z",
    fill: "#FFE900"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M93.139 20.9399C93.139 20.9399 102.58 0.726126 108.027 6.05192C113.474 11.3777 93.139 20.9399 93.139 20.9399Z",
    fill: "#FFE900"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 20.9399C93.1406 20.9399 72.9268 11.4988 78.2526 6.05192C83.5784 0.847162 93.1406 20.9399 93.1406 20.9399Z",
    fill: "#FFE900"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M93.139 21.0625C93.139 21.0625 113.353 30.5037 108.027 35.9505C102.701 41.1553 93.139 21.0625 93.139 21.0625Z",
    fill: "#FFE900"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1407 21.0612C93.1407 21.0612 108.392 37.2807 101.493 40.3067C94.5932 43.3328 93.1407 21.0612 93.1407 21.0612Z",
    fill: "#FAD300"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 20.9399C93.1406 20.9399 77.8895 4.72046 84.7888 1.69444C91.6882 -1.33158 93.1406 20.9399 93.1406 20.9399Z",
    fill: "#FAD300"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 21.0626C93.1406 21.0626 76.9212 36.3137 73.8951 29.4144C70.8691 22.394 93.1406 21.0626 93.1406 21.0626Z",
    fill: "#FAD300"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2604 20.9399C93.2604 20.9399 109.48 5.68879 112.506 12.5881C115.411 19.6085 93.2604 20.9399 93.2604 20.9399Z",
    fill: "#FAD300"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 21.0616C93.1406 21.0616 92.4144 43.3332 85.394 40.5492C78.3737 37.7653 93.1406 21.0616 93.1406 21.0616Z",
    fill: "#FAD300"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1387 20.9399C93.1387 20.9399 93.865 -1.33158 100.885 1.45237C107.906 4.23631 93.1387 20.9399 93.1387 20.9399Z",
    fill: "#FAD300"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 20.9399C93.1406 20.9399 70.8691 20.2137 73.653 13.1933C76.437 6.294 93.1406 20.9399 93.1406 20.9399Z",
    fill: "#FAD300"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2599 21.0616C93.2599 21.0616 115.531 21.7879 112.747 28.8082C109.964 35.7076 93.2599 21.0616 93.2599 21.0616Z",
    fill: "#FAD300"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M89.75 21.0601C89.75 19.2445 91.2025 17.6709 93.1391 17.6709C94.9547 17.6709 96.5283 19.1234 96.5283 21.0601C96.5283 22.8757 95.0758 24.4492 93.1391 24.4492C91.3235 24.4492 89.75 22.8757 89.75 21.0601Z",
    fill: "#FAD300"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1393 190.06C93.1393 190.06 100.644 211 93.1393 211C85.6347 211 93.1393 190.06 93.1393 190.06Z",
    fill: "#FFE900"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1392 189.94C93.1392 189.94 85.6346 169 93.1392 169C100.765 169 93.1392 189.94 93.1392 189.94Z",
    fill: "#FFE900"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 190.061C93.1406 190.061 72.2005 197.565 72.2005 190.061C72.2005 182.556 93.1406 190.061 93.1406 190.061Z",
    fill: "#FFE900"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2601 190.061C93.2601 190.061 114.2 182.556 114.2 190.061C114.2 197.565 93.2601 190.061 93.2601 190.061Z",
    fill: "#FFE900"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 190.061C93.1406 190.061 83.6994 210.275 78.2526 204.949C72.9268 199.502 93.1406 190.061 93.1406 190.061Z",
    fill: "#FFE900"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M93.139 189.94C93.139 189.94 102.58 169.726 108.027 175.052C113.474 180.378 93.139 189.94 93.139 189.94Z",
    fill: "#FFE900"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 189.94C93.1406 189.94 72.9268 180.499 78.2526 175.052C83.5784 169.847 93.1406 189.94 93.1406 189.94Z",
    fill: "#FFE900"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M93.139 190.062C93.139 190.062 113.353 199.504 108.027 204.951C102.701 210.155 93.139 190.062 93.139 190.062Z",
    fill: "#FFE900"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1407 190.061C93.1407 190.061 108.392 206.281 101.493 209.307C94.5932 212.333 93.1407 190.061 93.1407 190.061Z",
    fill: "#FAD300"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 189.94C93.1406 189.94 77.8895 173.72 84.7888 170.694C91.6882 167.668 93.1406 189.94 93.1406 189.94Z",
    fill: "#FAD300"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 190.063C93.1406 190.063 76.9212 205.314 73.8951 198.414C70.8691 191.394 93.1406 190.063 93.1406 190.063Z",
    fill: "#FAD300"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2604 189.94C93.2604 189.94 109.48 174.689 112.506 181.588C115.411 188.608 93.2604 189.94 93.2604 189.94Z",
    fill: "#FAD300"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 190.062C93.1406 190.062 92.4144 212.333 85.394 209.549C78.3737 206.765 93.1406 190.062 93.1406 190.062Z",
    fill: "#FAD300"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1387 189.94C93.1387 189.94 93.865 167.668 100.885 170.452C107.906 173.236 93.1387 189.94 93.1387 189.94Z",
    fill: "#FAD300"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 189.94C93.1406 189.94 70.8691 189.214 73.653 182.193C76.437 175.294 93.1406 189.94 93.1406 189.94Z",
    fill: "#FAD300"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2599 190.062C93.2599 190.062 115.531 190.788 112.747 197.808C109.964 204.708 93.2599 190.062 93.2599 190.062Z",
    fill: "#FAD300"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M89.75 190.06C89.75 188.244 91.2025 186.671 93.1391 186.671C94.9547 186.671 96.5283 188.123 96.5283 190.06C96.5283 191.876 95.0758 193.449 93.1391 193.449C91.3235 193.449 89.75 191.876 89.75 190.06Z",
    fill: "#FAD300"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1393 356.06C91.1393 356.06 98.6438 377 91.1393 377C83.6347 377 91.1393 356.06 91.1393 356.06Z",
    fill: "#FFE900"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1392 355.94C91.1392 355.94 83.6346 335 91.1392 335C98.7648 335 91.1392 355.94 91.1392 355.94Z",
    fill: "#FFE900"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 356.061C91.1406 356.061 70.2005 363.565 70.2005 356.061C70.2005 348.556 91.1406 356.061 91.1406 356.061Z",
    fill: "#FFE900"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2601 356.061C91.2601 356.061 112.2 348.556 112.2 356.061C112.2 363.565 91.2601 356.061 91.2601 356.061Z",
    fill: "#FFE900"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 356.061C91.1406 356.061 81.6994 376.275 76.2526 370.949C70.9268 365.502 91.1406 356.061 91.1406 356.061Z",
    fill: "#FFE900"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M91.139 355.94C91.139 355.94 100.58 335.726 106.027 341.052C111.474 346.378 91.139 355.94 91.139 355.94Z",
    fill: "#FFE900"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 355.94C91.1406 355.94 70.9268 346.499 76.2526 341.052C81.5784 335.847 91.1406 355.94 91.1406 355.94Z",
    fill: "#FFE900"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M91.139 356.062C91.139 356.062 111.353 365.504 106.027 370.951C100.701 376.155 91.139 356.062 91.139 356.062Z",
    fill: "#FFE900"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1407 356.061C91.1407 356.061 106.392 372.281 99.4925 375.307C92.5932 378.333 91.1407 356.061 91.1407 356.061Z",
    fill: "#FAD300"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 355.94C91.1406 355.94 75.8895 339.72 82.7888 336.694C89.6882 333.668 91.1406 355.94 91.1406 355.94Z",
    fill: "#FAD300"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 356.063C91.1406 356.063 74.9212 371.314 71.8951 364.414C68.8691 357.394 91.1406 356.063 91.1406 356.063Z",
    fill: "#FAD300"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2604 355.94C91.2604 355.94 107.48 340.689 110.506 347.588C113.411 354.608 91.2604 355.94 91.2604 355.94Z",
    fill: "#FAD300"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 356.062C91.1406 356.062 90.4144 378.333 83.394 375.549C76.3737 372.765 91.1406 356.062 91.1406 356.062Z",
    fill: "#FAD300"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1387 355.94C91.1387 355.94 91.865 333.668 98.8854 336.452C105.906 339.236 91.1387 355.94 91.1387 355.94Z",
    fill: "#FAD300"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1406 355.94C91.1406 355.94 68.8691 355.214 71.653 348.193C74.437 341.294 91.1406 355.94 91.1406 355.94Z",
    fill: "#FAD300"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2599 356.062C91.2599 356.062 113.531 356.788 110.747 363.808C107.964 370.708 91.2599 356.062 91.2599 356.062Z",
    fill: "#FAD300"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M87.75 356.06C87.75 354.244 89.2025 352.671 91.1391 352.671C92.9547 352.671 94.5283 354.123 94.5283 356.06C94.5283 357.876 93.0758 359.449 91.1391 359.449C89.3235 359.449 87.75 357.876 87.75 356.06Z",
    fill: "#FAD300"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1393 148.06C93.1393 148.06 100.644 169 93.1393 169C85.6347 169 93.1393 148.06 93.1393 148.06Z",
    fill: "#FFE900"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1392 147.94C93.1392 147.94 85.6346 127 93.1392 127C100.765 127 93.1392 147.94 93.1392 147.94Z",
    fill: "#FFE900"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 148.061C93.1406 148.061 72.2005 155.565 72.2005 148.061C72.2005 140.556 93.1406 148.061 93.1406 148.061Z",
    fill: "#FFE900"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2601 148.061C93.2601 148.061 114.2 140.556 114.2 148.061C114.2 155.565 93.2601 148.061 93.2601 148.061Z",
    fill: "#FFE900"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 148.061C93.1406 148.061 83.6994 168.275 78.2526 162.949C72.9268 157.502 93.1406 148.061 93.1406 148.061Z",
    fill: "#FFE900"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M93.139 147.94C93.139 147.94 102.58 127.726 108.027 133.052C113.474 138.378 93.139 147.94 93.139 147.94Z",
    fill: "#FFE900"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 147.94C93.1406 147.94 72.9268 138.499 78.2526 133.052C83.5784 127.847 93.1406 147.94 93.1406 147.94Z",
    fill: "#FFE900"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M93.139 148.062C93.139 148.062 113.353 157.504 108.027 162.951C102.701 168.155 93.139 148.062 93.139 148.062Z",
    fill: "#FFE900"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1407 148.061C93.1407 148.061 108.392 164.281 101.493 167.307C94.5932 170.333 93.1407 148.061 93.1407 148.061Z",
    fill: "#FAD300"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 147.94C93.1406 147.94 77.8895 131.72 84.7888 128.694C91.6882 125.668 93.1406 147.94 93.1406 147.94Z",
    fill: "#FAD300"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 148.063C93.1406 148.063 76.9212 163.314 73.8951 156.414C70.8691 149.394 93.1406 148.063 93.1406 148.063Z",
    fill: "#FAD300"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2604 147.94C93.2604 147.94 109.48 132.689 112.506 139.588C115.411 146.608 93.2604 147.94 93.2604 147.94Z",
    fill: "#FAD300"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 148.062C93.1406 148.062 92.4144 170.333 85.394 167.549C78.3737 164.765 93.1406 148.062 93.1406 148.062Z",
    fill: "#FAD300"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1387 147.94C93.1387 147.94 93.865 125.668 100.885 128.452C107.906 131.236 93.1387 147.94 93.1387 147.94Z",
    fill: "#FAD300"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 147.94C93.1406 147.94 70.8691 147.214 73.653 140.193C76.437 133.294 93.1406 147.94 93.1406 147.94Z",
    fill: "#FAD300"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2599 148.062C93.2599 148.062 115.531 148.788 112.747 155.808C109.964 162.708 93.2599 148.062 93.2599 148.062Z",
    fill: "#FAD300"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M89.75 148.06C89.75 146.244 91.2025 144.671 93.1391 144.671C94.9547 144.671 96.5283 146.123 96.5283 148.06C96.5283 149.876 95.0758 151.449 93.1391 151.449C91.3235 151.449 89.75 149.876 89.75 148.06Z",
    fill: "#FAD300"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1393 232.06C92.1393 232.06 99.6438 253 92.1393 253C84.6347 253 92.1393 232.06 92.1393 232.06Z",
    fill: "#FFE900"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1392 231.94C92.1392 231.94 84.6346 211 92.1392 211C99.7648 211 92.1392 231.94 92.1392 231.94Z",
    fill: "#FFE900"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1406 232.061C92.1406 232.061 71.2005 239.565 71.2005 232.061C71.2005 224.556 92.1406 232.061 92.1406 232.061Z",
    fill: "#FFE900"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2601 232.061C92.2601 232.061 113.2 224.556 113.2 232.061C113.2 239.565 92.2601 232.061 92.2601 232.061Z",
    fill: "#FFE900"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1406 232.061C92.1406 232.061 82.6994 252.275 77.2526 246.949C71.9268 241.502 92.1406 232.061 92.1406 232.061Z",
    fill: "#FFE900"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M92.139 231.94C92.139 231.94 101.58 211.726 107.027 217.052C112.474 222.378 92.139 231.94 92.139 231.94Z",
    fill: "#FFE900"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1406 231.94C92.1406 231.94 71.9268 222.499 77.2526 217.052C82.5784 211.847 92.1406 231.94 92.1406 231.94Z",
    fill: "#FFE900"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M92.139 232.062C92.139 232.062 112.353 241.504 107.027 246.951C101.701 252.155 92.139 232.062 92.139 232.062Z",
    fill: "#FFE900"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1407 232.061C92.1407 232.061 107.392 248.281 100.493 251.307C93.5932 254.333 92.1407 232.061 92.1407 232.061Z",
    fill: "#FAD300"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1406 231.94C92.1406 231.94 76.8895 215.72 83.7888 212.694C90.6882 209.668 92.1406 231.94 92.1406 231.94Z",
    fill: "#FAD300"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1406 232.063C92.1406 232.063 75.9212 247.314 72.8951 240.414C69.8691 233.394 92.1406 232.063 92.1406 232.063Z",
    fill: "#FAD300"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2604 231.94C92.2604 231.94 108.48 216.689 111.506 223.588C114.411 230.608 92.2604 231.94 92.2604 231.94Z",
    fill: "#FAD300"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1406 232.062C92.1406 232.062 91.4144 254.333 84.394 251.549C77.3737 248.765 92.1406 232.062 92.1406 232.062Z",
    fill: "#FAD300"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1387 231.94C92.1387 231.94 92.865 209.668 99.8854 212.452C106.906 215.236 92.1387 231.94 92.1387 231.94Z",
    fill: "#FAD300"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1406 231.94C92.1406 231.94 69.8691 231.214 72.653 224.193C75.437 217.294 92.1406 231.94 92.1406 231.94Z",
    fill: "#FAD300"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2599 232.062C92.2599 232.062 114.531 232.788 111.747 239.808C108.964 246.708 92.2599 232.062 92.2599 232.062Z",
    fill: "#FAD300"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M88.75 232.06C88.75 230.244 90.2025 228.671 92.1391 228.671C93.9547 228.671 95.5283 230.123 95.5283 232.06C95.5283 233.876 94.0758 235.449 92.1391 235.449C90.3235 235.449 88.75 233.876 88.75 232.06Z",
    fill: "#FAD300"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6002 472.8C7.50019 472.8 0.000198364 480.3 0.000198364 489.4C0.000198364 498.5 7.50019 506 16.6002 506C25.7002 506 33.2002 498.5 33.2002 489.4C33.2002 480.2 25.8002 472.8 16.6002 472.8Z",
    fill: "#FFE900"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1996 484.099C9.59962 484.099 5.79961 487.899 5.79961 492.499C5.79961 497.099 9.59962 500.899 14.1996 500.899C18.7996 500.899 22.5996 497.099 22.5996 492.499C22.5996 487.899 18.7996 484.099 14.1996 484.099Z",
    fill: "#FAD300"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6002 439.8C7.50019 439.8 0.000198364 447.3 0.000198364 456.4C0.000198364 465.5 7.50019 473 16.6002 473C25.7002 473 33.2002 465.5 33.2002 456.4C33.2002 447.2 25.8002 439.8 16.6002 439.8Z",
    fill: "#FFE900"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1996 451.099C9.59962 451.099 5.79961 454.899 5.79961 459.499C5.79961 464.099 9.59962 467.899 14.1996 467.899C18.7996 467.899 22.5996 464.099 22.5996 459.499C22.5996 454.899 18.7996 451.099 14.1996 451.099Z",
    fill: "#FAD300"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6002 409.8C7.50019 409.8 0.000198364 417.3 0.000198364 426.4C0.000198364 435.5 7.50019 443 16.6002 443C25.7002 443 33.2002 435.5 33.2002 426.4C33.2002 417.2 25.8002 409.8 16.6002 409.8Z",
    fill: "#FFE900"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1996 421.099C9.59962 421.099 5.79961 424.899 5.79961 429.499C5.79961 434.099 9.59962 437.899 14.1996 437.899C18.7996 437.899 22.5996 434.099 22.5996 429.499C22.5996 424.899 18.7996 421.099 14.1996 421.099Z",
    fill: "#FAD300"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6002 376.8C7.50019 376.8 0.000198364 384.3 0.000198364 393.4C0.000198364 402.5 7.50019 410 16.6002 410C25.7002 410 33.2002 402.5 33.2002 393.4C33.2002 384.2 25.8002 376.8 16.6002 376.8Z",
    fill: "#FFE900"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1996 388.099C9.59962 388.099 5.79961 391.899 5.79961 396.499C5.79961 401.099 9.59962 404.899 14.1996 404.899C18.7996 404.899 22.5996 401.099 22.5996 396.499C22.5996 391.899 18.7996 388.099 14.1996 388.099Z",
    fill: "#FAD300"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6002 346.8C7.50019 346.8 0.000198364 354.3 0.000198364 363.4C0.000198364 372.5 7.50019 380 16.6002 380C25.7002 380 33.2002 372.5 33.2002 363.4C33.2002 354.2 25.8002 346.8 16.6002 346.8Z",
    fill: "#FFE900"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1996 358.099C9.59962 358.099 5.79961 361.899 5.79961 366.499C5.79961 371.099 9.59962 374.899 14.1996 374.899C18.7996 374.899 22.5996 371.099 22.5996 366.499C22.5996 361.899 18.7996 358.099 14.1996 358.099Z",
    fill: "#FAD300"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6002 312.8C7.50019 312.8 0.000198364 320.3 0.000198364 329.4C0.000198364 338.5 7.50019 346 16.6002 346C25.7002 346 33.2002 338.5 33.2002 329.4C33.2002 320.2 25.8002 312.8 16.6002 312.8Z",
    fill: "#FFE900"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1996 324.099C9.59962 324.099 5.79961 327.899 5.79961 332.499C5.79961 337.099 9.59962 340.899 14.1996 340.899C18.7996 340.899 22.5996 337.099 22.5996 332.499C22.5996 327.899 18.7996 324.099 14.1996 324.099Z",
    fill: "#FAD300"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6002 282.8C7.50019 282.8 0.000198364 290.3 0.000198364 299.4C0.000198364 308.5 7.50019 316 16.6002 316C25.7002 316 33.2002 308.5 33.2002 299.4C33.2002 290.2 25.8002 282.8 16.6002 282.8Z",
    fill: "#FFE900"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1996 294.099C9.59962 294.099 5.79961 297.899 5.79961 302.499C5.79961 307.099 9.59962 310.899 14.1996 310.899C18.7996 310.899 22.5996 307.099 22.5996 302.499C22.5996 297.899 18.7996 294.099 14.1996 294.099Z",
    fill: "#FAD300"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6002 249.8C7.50019 249.8 0.000198364 257.3 0.000198364 266.4C0.000198364 275.5 7.50019 283 16.6002 283C25.7002 283 33.2002 275.5 33.2002 266.4C33.2002 257.2 25.8002 249.8 16.6002 249.8Z",
    fill: "#FFE900"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1996 261.099C9.59962 261.099 5.79961 264.899 5.79961 269.499C5.79961 274.099 9.59962 277.899 14.1996 277.899C18.7996 277.899 22.5996 274.099 22.5996 269.499C22.5996 264.899 18.7996 261.099 14.1996 261.099Z",
    fill: "#FAD300"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6002 219.8C7.50019 219.8 0.000198364 227.3 0.000198364 236.4C0.000198364 245.5 7.50019 253 16.6002 253C25.7002 253 33.2002 245.5 33.2002 236.4C33.2002 227.2 25.8002 219.8 16.6002 219.8Z",
    fill: "#FFE900"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1996 231.099C9.59962 231.099 5.79961 234.899 5.79961 239.499C5.79961 244.099 9.59962 247.899 14.1996 247.899C18.7996 247.899 22.5996 244.099 22.5996 239.499C22.5996 234.899 18.7996 231.099 14.1996 231.099Z",
    fill: "#FAD300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomFlower);
export default __webpack_public_path__ + "static/media/bottom_flower.99d33bda42375491663fe1ede97a96a1.svg";
export { ForwardRef as ReactComponent };